import { useQuery } from '@tanstack/react-query';
import { useAxios } from '../../../api/axios';
import { useTranslation } from 'react-i18next';

export const useRpaUploadUrl = (investorObj: any) => {
  const axios = useAxios();
  const { t } = useTranslation();
  const urlKey = t('rpa-upload-url-api');
  const contactId = investorObj?.id;

  const Query = useQuery({
    queryKey: ['rpa-upload-url-list', contactId],
    queryFn: async () => {
      const res = await axios.get(`${urlKey}/${contactId}`);
      return res?.data?.data;
    },
    enabled: !!contactId,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  return Query;
};
